import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeleteRoutingModule } from './delete-routing.module';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { ParentLoginComponent } from './parent-login/parent-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';




@NgModule({
  declarations: [
    DeleteDialogComponent,
    ParentLoginComponent,
    
  ],
  imports: [
    CommonModule,
    DeleteRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),

  ]
})
export class DeleteModule { }
